import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Team.scss';
import Sreekanth from '../img/Team/Sreekanth.svg';
import Vijay from '../img/Team/Vijay.svg';
import Prashant from '../img/Team/Prashant.svg';
import Gopal from '../img/Team/Gopal.svg';
import Nicole from '../img/Team/Nicole.svg';
import Sham from '../img/Team/Sham.svg';
import Fahriza from '../img/Team/Fahriza.svg'
import Dennis from '../img/Team/Dennis.svg'
import Roxana from '../img/Team/Roxana.svg'

export default function Team() {
    return (
        <div id="Team" className="team-tier-circle">
            <Container className="team-bg-color">
                <div className="text-center team">
                    <h1>
                        <span className="team__heading-1">Team</span>{' '}
                        <span className="team__heading-2">& Advisors</span>
                    </h1>
                </div>
                <Row>
                    <Col xs={12} md={4} className="text-center team-pad-mobile-col-1">
                        <img src={Sreekanth} alt="Shreekanth" />
                        <h1 className="team-title">Sreekanth Kalapur</h1>
                        <h5 className="team-description word-setting">
                            VP Engineering at Polymorph acquired by Walmart Labs. 
                            15+ years of experience building highly-scalable products. Alumni of BITS-Pilani.
                        </h5>
                    </Col>
                    <Col xs={12} md={4} className="text-center team-pad-mobile">
                        <img src={Vijay} alt="Vijay" />
                        <h1 className="team-title">Vijay Kalangi</h1>
                        <h5 className="team-description word-setting">
                        Co-founder & CTO of a edu-tech firm with multi-million dollar revenue.
                        14+ years of experience building products in learning and edu-tech. Alumnus of BITS-Pilani.
                        </h5>
                    </Col>

                    <Col xs={12} md={4} className="text-center team-pad-mobile">
                        <img src={Nicole} alt="Nicole" />
                        <h1 className="team-title">Nicholas Gregory</h1>
                        <h5 className="team-description word-setting">
                        CEO of CommerceBlock. Technology leader and Bitcoin expert since 2012.
                        Ex - Vice President at Merrill Lynch, Bank of America & JPMorgan.
                        </h5>
                    </Col>

                    {/* Second row */}
                    <Col xs={12} md={4} className="text-center team-padding">
                        <img src={Gopal} alt="Gopal" />
                        <h1 className="team-title">Gopal Kishore</h1>
                        <h5 className="team-description word-setting">
                            15 years of experience in digital marketing. Led marketing for
                            technology start-ups and public relations agencies. Masters in
                            Journalism, and a degree in visual communications.
                        </h5>
                    </Col>
                    <Col xs={12} md={4} className="text-center team-padding">
                        <img src={Prashant} alt="Prashant" />
                        <h1 className="team-title">Prashanth K Rao</h1>
                        <h5 className="team-description word-setting">
                            15 years of Risk & compliance experience in companies like KPMG &
                            Deloitte. Global
                            <br /> Compliance Pillar Lead at ABInBeV. Alumni of IIIT & NIT.
                        </h5>
                    </Col>
                    <Col xs={12} md={4} className="text-center team-padding">
                        <img src={Sham} alt="Sham" />
                        <h1 className="team-title">Shyam Mohan K</h1>
                        <h5 className="team-description text-class word-setting">
                            12+ years experience in developing well-engineered software. Cofounder
                            of multiple technology startups. Bachelors in Computer Science.
                        </h5>
                    </Col>

                    {/* third row */}
                    <Col xs={12} md={4} className="third-row-margin text-center team-padding">
                        <img src={Fahriza} alt="Fahriza" />
                        <h1 className="team-title">Fahriza Shuaib</h1>
                        <h5 className="team-description word-setting">
                        Community Manager
                        <br />
                        Private Group Analyst
                        <br />
                        Technical Chart Analyst
                        <br />
                        5 years+ in cryptocurrencies market
                        </h5>
                    </Col>
                    <Col xs={12} md={4} className="third-row-margin text-center team-padding">
                        <img src={Dennis} alt="Dennis" />
                        <h1 className="team-title">Dennis Czempik</h1>
                        <h5 className="team-description word-setting">
                        Crypto entrepreneur since 2017
                        <br />
                        Helped raise funds for several projects via private pools
                        </h5>
                    </Col>
                    <Col xs={12} md={4} className="third-row-margin mob-margin text-center team-padding">
                        <img src={Roxana} alt="Roxana" />
                        <h1 className="team-title">Roxana Nasoi</h1>
                        <h5 className="team-description text-class word-setting">
                        Head of growth, Launchpoool
                        <br />
                        Privacy Advocate
                        <br />
                        Community Hacker
                        <br />
                        Business Strategist
                        </h5>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
